<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  enabled: { type: Boolean, default: true },
  quantity: { type: Number, default: 0 },
  readonly: { type: Boolean, default: false },
  showQuantity: { type: Boolean, default: false },
  toggleLabel: { type: String, default: '' },
});

const emit = defineEmits(['update:enabled', 'update:quantity']);
const { t } = useI18n();

const quantityOptions = computed(() => {
  const maximum = Math.max(props.quantity, 4);
  return Array.from({ length: maximum + 1 }, (_, value) => value);
});
</script>

<template>
  <div class="flex flex-wrap items-end gap-4">
    <div v-if="toggleLabel" class="flex min-h-10 items-center gap-3">
      <ToggleSwitch
        :model-value="enabled"
        :disabled="readonly"
        @update:model-value="emit('update:enabled', $event)"
      />
      <span class="text-sm font-medium text-lais-text">{{ toggleLabel }}</span>
    </div>

    <LaisField
      v-if="showQuantity && enabled"
      :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.SHEET.QUANTITY')"
    >
      <select
        :value="quantity"
        :disabled="readonly"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:cursor-not-allowed disabled:opacity-70"
        @change="emit('update:quantity', Number($event.target.value))"
      >
        <option v-for="option in quantityOptions" :key="option" :value="option">
          {{ option }}
        </option>
      </select>
    </LaisField>
  </div>
</template>
